import { atom } from "jotai";

export const langCodeAtom = atom("en");